var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('confirmacao',{attrs:{"block_menu":true,"id_medico_fixo":_vm.$store.state.user.id_pessoa}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }